import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'dd-v-spec-page',
  templateUrl: './v-spec-page.component.html',
  styleUrls: ['./v-spec-page.component.scss']
})
export class VSpecPageComponent implements OnInit {
  ngOnInit() {
    //
    // Get Vehicle Data
    //
    const vehicle = this.route.snapshot.data;
    //
    // This data can now be sent to the store for persistence of vehicle data.
    //
  }

  constructor(private route: ActivatedRoute) {

  }
}
